const DEFAULT_TIMEOUT = 15000
const DEFAULT_UPLOAD_TIMEOUT = 30000

function env(name, fallback = '') {
  try {
    const v = import.meta.env[name]
    return v === undefined || v === null ? fallback : v
  } catch (e) {
    return fallback
  }
}

export default {
  baseURL: String(env('VITE_API_BASE', '')).replace(/\/+$/, ''),
  prefix: String(env('VITE_API_PREFIX', '/api/v1')).replace(/\/+$/, ''),
  timeout: Number(env('VITE_API_TIMEOUT', DEFAULT_TIMEOUT)) || DEFAULT_TIMEOUT,
  uploadTimeout: Number(env('VITE_API_UPLOAD_TIMEOUT', DEFAULT_UPLOAD_TIMEOUT)) || DEFAULT_UPLOAD_TIMEOUT,
  successCode: 0,
  tokenKey: env('VITE_TOKEN_KEY', 'mhxy-token'),
  contentType: 'application/json'
}
